import { DragEndEvent } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';

import { findIndexByField } from '../../../../../../shared/utils/arrayUtils';
import { Video } from '../../../../../interface/video';

export const updateVideosOrder = (
  event: DragEndEvent,
  videos: Video[],
  reorderVideos: (videos: Video[]) => void,
) => {
  const { active, over } = event;

  if (!over || !active.id || !over.id || active.id === over.id) {
    return;
  }

  const oldIndex = findIndexByField(videos, { id: active.id as number });
  const newIndex = findIndexByField(videos, { id: over.id as number });

  if (oldIndex === -1 || newIndex === -1) {
    console.error(`Video not found: ${active.id} or ${over.id}`);
    return;
  }

  const reorderedVideos = arrayMove(videos, oldIndex, newIndex);

  reorderVideos(reorderedVideos);
};
